import React from 'react';
import FindMyReceipt from './FindMyReceipt';

export default class GuestReceiptContainer extends React.Component {
	constructor(props) {
		super(props);
	}
	
	render(){
		return(
			<div id="orders-section" className="site-container icon_button_content animate-in" aria-live="assertive">
				<div className="blurb text-center">
					<div className="title no-print">{this.props.resources["PWS.GuestCheckout.ReceiptTitle"]}</div>
					<div className="description no-print">{this.props.resources["PWS.GuestCheckout.ReceiptPageDescription"]}</div>
				</div>
				<FindMyReceipt resources={this.props.resources}/>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/GuestCheckout/GuestReceiptContainer.js